import { Bell, ChevronRight, Clock3, CreditCard, Database, LogOut, ShieldCheck, UserRound } from 'lucide-react'
import { useEffect, useState } from 'react'
import { openBillingPortal, myActiveSubscription } from '../lib/pocketbase'
import { useApp } from '../state/AppContext'
import type { SubscriptionSummary } from '../types'

function PlanSection() {
  const [subscription, setSubscription] = useState<SubscriptionSummary | null | undefined>(undefined)
  const [openingPortal, setOpeningPortal] = useState(false)

  useEffect(() => { myActiveSubscription().then(setSubscription) }, [])

  const manage = async () => {
    setOpeningPortal(true)
    try { window.location.href = (await openBillingPortal()).url }
    catch { setOpeningPortal(false) }
  }

  if (subscription === undefined) return null

  return <section className="settings-group">
    <p className="step-label">Seu plano</p>
    <div className="settings-info">
      <span><CreditCard /><i className="settings-label"><b>{subscription?.expand?.plan?.name || 'Sem plano ativo'}</b><small>{subscription ? `Desde ${new Date(subscription.started_at).toLocaleDateString('pt-BR')}` : 'Assine para continuar ouvindo'}</small></i></span>
    </div>
    <button type="button" className="button button--outline" style={{ marginTop: 12 }} disabled={openingPortal} onClick={subscription ? manage : () => { window.location.href = '/assinar' }}>
      {openingPortal ? 'Abrindo…' : subscription ? 'Gerenciar assinatura' : 'Ver planos'}
    </button>
  </section>
}

export function ProfilePage() {
  const { user, mode, backendAvailable, logout, finishOnboarding, busy } = useApp()
  const [editingTime, setEditingTime] = useState(false)
  const [preferredTime, setPreferredTime] = useState(user?.preferredTime || '20:00')

  if (!user) return null

  const save = async (overrides: { preferredTime?: string; notifications?: boolean }) => {
    try {
      await finishOnboarding({
        name: user.name,
        intention: user.intention || '',
        experience: user.experience || '',
        preferredTime: user.preferredTime || '20:00',
        notifications: user.notifications ?? true,
        ...overrides,
      })
    } catch { /* contexto */ }
  }

  return <div className="profile-page">
    <header className="page-heading"><div><p>Perfil e ajustes</p><h1>Seu jeito<br /><em>de escutar.</em></h1></div><UserRound /></header>
    <section className="profile-card"><div className="avatar">{user.name?.slice(0, 1).toUpperCase()}</div><div><h2>{user.name}</h2><p>{user.email}</p></div></section>
    <section className="settings-group">
      <p className="step-label">Sua experiência</p>
      <button type="button" onClick={() => { setPreferredTime(user.preferredTime || '20:00'); setEditingTime((value) => !value) }}>
        <span><Clock3 /><i className="settings-label"><b>Horário preferido</b><small>{user.preferredTime || 'Não definido'}</small></i></span>
        <ChevronRight />
      </button>
      {editingTime && <div className="settings-edit">
        <input type="time" value={preferredTime} onChange={(event) => setPreferredTime(event.target.value)} />
        <button type="button" className="button button--primary" disabled={busy} onClick={async () => { await save({ preferredTime }); setEditingTime(false) }}>{busy ? 'Salvando…' : 'Salvar'}</button>
      </div>}
      <label className="toggle-row">
        <span><Bell /><i className="settings-label"><b>Lembretes</b><small>{user.notifications ? 'Ativados' : 'Desativados'}</small></i></span>
        <input type="checkbox" checked={user.notifications ?? false} disabled={busy} onChange={(event) => void save({ notifications: event.target.checked })} />
        <i className="toggle-switch" />
      </label>
    </section>
    {mode !== 'demo' && <PlanSection />}
    <section className="settings-group"><p className="step-label">Dados e privacidade</p><div className="settings-info"><span><Database /><i className="settings-label"><b>Modo de dados</b><small>{mode === 'demo' ? 'Demonstração local' : 'Conectado'}</small></i></span><span className={`connection-dot ${backendAvailable ? 'is-online' : ''}`} /></div><div className="settings-info"><span><ShieldCheck /><i className="settings-label"><b>Privacidade</b><small>Suas anotações são privadas</small></i></span></div></section>
    <button className="logout-button" onClick={logout}><LogOut />Sair deste dispositivo</button>
    <p className="version">Música Com Você · MVP 0.1</p>
  </div>
}
